import { render } from "./product-result.vue?vue&type=template&id=60e31777"
import script from "./product-result.vue?vue&type=script&lang=js"
export * from "./product-result.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\MVC\\wwwroot\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__